import getLocal from '@/app/utils/getLocal';
import getUsCopy from './basis/us';
import getCaCopy from './basis/ca';
import getEuCopy from './basis/eu';
import getUkCopy from './basis/uk';
import getZaCopy from './basis/za';
import getAuCopy from './basis/au';
import getKrCopy from './basis/kr';
import getJpCopy from './basis/jp';
import getDeCopy from './basis/de';
import getItCopy from './basis/it';
import getFrCopy from './basis/fr';
import getEsCopy from './basis/es';

type FaqItemType = { subtitle: string; text: string };
export interface FaqProps {
    key?: number;
    title: string;
    content: FaqItemType[];
}

const faqsMap: Record<string, any> = {
    us: getUsCopy,
    ca: getCaCopy,
    eu: getEuCopy,
    uk: getUkCopy,
    za: getZaCopy,
    au: getAuCopy,
    kr: getKrCopy,
    jp: getJpCopy,
    de: getDeCopy,
    it: getItCopy,
    fr: getFrCopy,
    es: getEsCopy,
};

export default function useCopy(key?: string): FaqProps[] {
    const { locale } = getLocal();
    const func = faqsMap[locale] || getUsCopy;
    return func(key);
}
